import React from 'react'
import Rating from '@material-ui/lab/Rating';
import StarRoundedIcon from '@material-ui/icons/StarRounded';

export const RatingComponent = ({ item, rating }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between', border:"1px solid rgb(52,52,52)", cursor:"pointer"}} className='p-2' >
            <div className='mr-3'>{item}</div>
            <Rating 
                icon={<StarRoundedIcon className='icon_rating' />} 
                emptyIcon={<StarRoundedIcon className='icon_rating' style={{ color:'rgba(255,255,255,.70)' }} fontSize="inherit"/>} 
                variant='dark' 
                value={Number(rating)} 
                precision={0.1} 
                readOnly
            />
        </div>
    )
}
